// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e9PK","toggleWrap":"styles_toggleWrap__2selZ","content":"styles_content__1T9ik","selectAreaCode":"styles_selectAreaCode__1WElh"};